import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-59c13138"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["r", "cx", "cy"]
const _hoisted_3 = ["r", "cx", "cy"]

import { ref, onMounted, computed, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'pie-chart',
  props: {
    size: {},
    percent: {}
  },
  setup(__props: any) {

const props = __props;

const pie = ref<HTMLElement>();

const radius = computed(() => {
  return props.size / 4;
});

function createPie(): void {
  const circumference = 2 * Math.PI * radius.value;
  const chordLength = (props.percent / 100) * circumference;
  const strokeWidth = radius.value * 2;
  const pieElement = pie.value as HTMLElement;
  pieElement.style.strokeDasharray = `${chordLength} ${circumference}`;
  pieElement.style["stroke-width"] = strokeWidth;
  pieElement.style.stroke = props.percent > 0 ? "" : "white";
}

onMounted(() => createPie());

watch(props, createPie);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: _ctx.size,
    height: _ctx.size,
    class: "pie-chart"
  }, [
    _createElementVNode("circle", {
      ref_key: "pie",
      ref: pie,
      r: radius.value,
      cx: radius.value * 2,
      cy: radius.value * 2,
      class: "pie"
    }, null, 8, _hoisted_2),
    _createElementVNode("circle", {
      r: radius.value * 2,
      cx: radius.value * 2,
      cy: radius.value * 2,
      stroke: "black",
      "stroke-width": "2",
      fill: "none",
      class: "outline"
    }, null, 8, _hoisted_3)
  ], 8, _hoisted_1))
}
}

})